// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { DatePicker } from 'antd';
import { RangePickerDateProps } from 'antd/lib/date-picker/generatePicker';
import React, { ReactElement } from 'react';
import { Moment } from 'moment';
import { useStorageOptions } from '@Hooks/useStorageOptions';

import './THRangePicker.scss';

const showTimeDefaultValue = { showHour: true, showMinute: true, showSecond: true };

interface THRangePickerProps extends RangePickerDateProps<Moment> {
    borderless?: boolean;
}

export const THRangePicker = ({
    borderless = false,
    showTime = showTimeDefaultValue,
    showNow = true,
    className,
    ...props
}: THRangePickerProps): ReactElement => {
    const { defaultDateFormat } = useStorageOptions();

    return (
        <DatePicker.RangePicker
            className={classList('th-range-picker', className, { 'no-border': borderless })}
            format={defaultDateFormat}
            dropdownClassName="th-range-picker__dropdown"
            showTime={showTime}
            showNow={showNow}
            {...props}
        />
    );
};
